import { loadProgress, progressByGroup } from '@/core/progress'
import { useSettings } from './settings'

/** Fortschritt je Gruppe, Schwachstellen zuerst, im gewählten Bereich. */
export function ProgressView() {
  const { t, pick, settings } = useSettings()
  const groups = progressByGroup(loadProgress(), settings.bereich)
  const seen = groups.reduce((n, g) => n + g.seen, 0)
  const total = groups.reduce((n, g) => n + g.cards, 0)
  // Schwächste heißt: schon gesehen und am seltensten richtig. Was man nie gesehen hat,
  // ist keine Schwäche, sondern noch nicht dran.
  const schwaechste = groups.filter((g) => g.seen > 0).sort((a, b) => a.rate - b.rate)[0]

  return (
    <section className="progress" data-testid="progress" data-bereich={settings.bereich}>
      <p className="detail__text">
        {t('progress.summary', { seen, total })}
      </p>
      {/* Die Körbe sagen, wie viel wackelt. Welcher Stoff es ist, sagt dieser Satz, und
          er stand vorher auf dem Startbildschirm, den es nicht mehr gibt. */}
      {schwaechste && (
        <p className="detail__text detail__note" data-testid="progress-schwaechste">
          {t('progress.weakest', {
            group: pick(schwaechste.label),
            rate: Math.round(schwaechste.rate * 100),
          })}
        </p>
      )}
      <ul className="progress__list">
        {groups.map((group) => (
          <li key={group.key} className="progress__row" data-group={group.key}>
            <span className="progress__label">{pick(group.label)}</span>
            <span className="progress__bar" aria-hidden="true">
              <span
                className="progress__fill"
                style={{ width: `${Math.round((group.seen / group.cards) * 100)}%` }}
                data-rate={group.rate.toFixed(2)}
              />
            </span>
            <span className="progress__value">
              {group.seen}/{group.cards}
              {group.seen > 0 ? ` · ${Math.round(group.rate * 100)} %` : ''}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
